<nav class="navbar-header">
    <a routerLink="/dashboard">
        <img src="assets/img/logo_dash.png" style="max-width: 197px;">
    </a>
    <div _ngcontent-fie-c51="" class="flex-spacer"></div>
    <a mat-button routerLink="create-games" class="bt" routerLinkActive="activo">Crea tu juego</a>
    <a mat-button routerLink="my-games" class="bt" routerLinkActive="activo">Mis videojuegos</a>
    <a mat-button routerLink="premiun" class="bt" routerLinkActive="activo">Membresías</a>
    <!--button mat-button class="bt" (click)="activateModal()">Ayuda</button-->
    <a mat-button class="avatar" [matMenuTriggerFor]="menu">
        <img src="{{image}}">
    </a>
</nav>

<mat-menu #menu="matMenu">
    <button mat-menu-item routerLink="profile">Mi perfil</button>
    <button mat-menu-item (click)="logout()">Cerrar sesion</button>
</mat-menu>

<app-modal-help *ngIf="modalCreate" [accion]="accion" (saveButton)="updateModalCreate($event)">
</app-modal-help>